import { StepDto } from '../gestione-step/step-dto';
import {QRCodeDto} from "../gestione-partite/qrcode-dto";

export interface MissionClassDto {
  id: string; // GUID
  name: string;
  description: string;
}

/* export interface MissionProgressDto {
  id: string; // GUID
  missionFk: string;
  userFk: string;
  createdAt: string; // ISO date
  updatedAt: string; // ISO date
} */

export interface MissionProgressDto {
  id: string;
  lives: number;
  points: number;
  missionFk: string;
  teamFk: string;
  createdAt: string;
  updatedAt: string;
}
/* export interface MissionDto {
  id: string; // GUID
  name: string;
  description: string;
  unlockType: UnlockType;
  configurationJson: string;
  isSecondary: boolean;
  pointsRedeem?: number;
  createdAt: string; // ISO date
  updatedAt?: string; // ISO date
  adventureFk: string;
  enigmas: EnigmaDto[];
  missionClassFk?: string;
  missionClass?: MissionClassDto;
  missionProgresses: MissionProgressDto[];
  hearts: number;
} */
export interface MissionDto {
  id: string;
  name: string;
  description: string;
  shortDescription: string;
  unlockType: UnlockType;
  configurationJson: string;
  isSecondary: boolean;
  pointsRedeem?: number;
  hearts: number;
  createdAt: string;
  updatedAt?: string;
  adventureFk: string;
  dependsOn?: string;
  steps: StepDto[];
  missionClassFk?: string;
  missionClass?: MissionClassDto;
  missionProgresses: MissionProgressDto[];
  missionUnlocked: MissionUnlockedDto[];
  qrCodes: QRCodeDto[];
}

export interface MissionUnlockedDto {
  id: string;
  missionFk: string;
  teamFk: string;
  adventureFk: string;
}


/* export interface CreateMission {
  name: string;
  description?: string;
  unlockType?: UnlockType;
  configurationJson?: TimeUnlockConfig | GpsUnlockConfig | {};
  isSecondary?: boolean;
  pointsRedeem?: number;
  adventureFk: string;
  missionClassFk?: string;
  hearts: number;
} */
export interface CreateMission {
  name: string;
  unlockType?: UnlockType;
  description: string;
  shortDescription: string;
  configurationJson?: TimeUnlockConfig | GpsUnlockConfig | LevelUnlockConfig | {};
  isSecondary?: boolean;
  pointsRedeem?: number;
  hearts: number;
  dependsOn?: string;
  adventureFk: string;
  missionClassFk?: string;
}

/* export interface UpdateMission {
  name: string;
  description?: string;
  unlockType?: UnlockType;
  configurationJson?: TimeUnlockConfig | GpsUnlockConfig | {};
  isSecondary?: boolean;
  pointsRedeem?: number;
  adventureFk: string;
  missionClassFk?: string;
  hearts: number;
} */

export interface UpdateMission {
  description: string;
  shortDescription: string;
  unlockType?: UnlockType;
  configurationJson?: TimeUnlockConfig | GpsUnlockConfig | LevelUnlockConfig | {};
  isSecondary?: boolean;
  pointsRedeem?: number;
  hearts: number;
  dependsOn?: string;
  adventureFk: string;
  missionClassFk?: string;
  name: string;
}

export interface CreateMissionClass {
  name: string;
  description?: string;
}

export interface UpdateMissionClass {
  name: string;
  description?: string;
}

export interface CreateMissionProgress {
  missionFk: string;
}

export interface TimeUnlockConfig {
  seconds: number;
  startDays?: string;
  endDays?: string;
  startAt?: string;
  endAt?: string;
}

export interface GpsUnlockConfig {
  gpsAddress?: string;
  gpsAddressUnlock?: string;
  latitudine: number;
  longitudine: number;
  gpsRadius: number;
}

export interface LevelUnlockConfig {
  RequiredLevel: number;
}

export enum UnlockType {
  immediate = 'immediate',
  time = 'time',
  gps = 'gps',
  qr = 'qr',
  zoom = 'zoom',
  level = 'level',
}

export const UNLOCK_TYPE_ICONS: Record<UnlockType, string> = {
  [UnlockType.immediate]: 'bolt',
  [UnlockType.time]: 'hourglass-high',
  [UnlockType.gps]: 'pin',
  [UnlockType.qr]: 'qrcode',
  [UnlockType.zoom]: 'zoom-in',
  [UnlockType.level]: 'bar-chart-steps',
};

export const UNLOCK_TYPE_LABEL: Record<UnlockType, string> = {
  [UnlockType.immediate]: 'Immediato',
  [UnlockType.time]: 'Tempo',
  [UnlockType.gps]: 'GPS',
  [UnlockType.qr]: 'QR Code',
  [UnlockType.zoom]: 'Zoom',
  [UnlockType.level]: 'Livello',
};
